<template>
  <b-container class="activity">
    <ArtistEditProfileTabs v-if="!isFanView" />

    <ProfileHero :artist="artist" v-if="isFanView && artist" />
    <ArtistProfileTabs :artist="artist" v-if="isFanView && artist" />

    <div class="post-message" v-if="!isFanView">
      <b-row>
        <b-col>
          <b-form-group label="Post a message"
                        description="Post a status update to your followers">
            <b-form-textarea :rows="5" :max-rows="10" required v-model="update.text"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group horizontal label="Visibility">
            <b-form-select v-model="update.visibility" id="visibility" :options="postVisibilities" />
          </b-form-group>
        </b-col>
        <b-col class="text-right">
          <b-button class="btn-rainbow" @click="postUpdate" :disabled="!update.text">Post update</b-button>
        </b-col>
      </b-row>

      <b-row v-if="update.visibility === 'private'">
        <b-col>
          <UserList v-model="recipients"
                    :canAdd="true"
                    :canRemove="true"
                    :requireUser="true"
                    :forceFan="true"
                    addLabel="Add recipient"
                    removeLabel="Remove recipient" />
        </b-col>
      </b-row>
    </div>

    <Feed :feed="feed" :artist="artist" :canManage="!isFanView" />

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .post-message {
    border-bottom: 1px solid $steel;
  }
</style>

<script>
import map from 'lodash/map'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ArtistEditProfileTabs from '@/components/widgets/ArtistEditProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'
import Feed from '@/components/widgets/Feed'
import UserList from '@/components/widgets/UserList'

import { postVisibilities } from '@/store/modules/feed'
import { profileHelpers } from '@/store/helpers'

export default {
  name: 'Activity',
  components: {
    FontAwesomeIcon,
    ArtistProfileTabs,
    ArtistEditProfileTabs,
    ProfileHero,
    Feed,
    UserList
  },
  data () {
    return {
      artist: null,
      recipients: [],
      update: {
        text: '',
        visibility: 'public'
      },
      feed: null
    }
  },
  computed: {
    isFanView () {
      return this.$route.params.artistId
    },
    postVisibilities () {
      return postVisibilities
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      try {
        if (this.$route.params.artistId) {
          this.artist = await this.$store.dispatch('artist/getArtist', {id: this.$route.params.artistId})
        } else {
          this.artist = this.$store.getters['artist/artist']
        }

        if (this.$route.query.thanks) {
          this.setupThanks(this.$route.query.thanks)
        }

        this.feed = (await this.$store.dispatch('feed/getUserFeed', {id: this.artist.profile.id})).results
      } catch (e) {
        console.log('[activity] failed to load artist and/or feed information', e)
        this.artist = null
        this.feed = []
      }
    },
    async setupThanks (handle) {
      let users = await this.$store.dispatch('profile/findProfile', { handle: handle })
      if (users && users.count) {
        this.recipients = [{
          handle: '@' + handle,
          user: users.results[0],
          name: profileHelpers.displayName(users.results[0])
        }]
        this.update.visibility = 'private'
        this.update.text = 'Thanks!'
      }
    },
    async postUpdate () {
      if (!this.update.text) return

      if (this.update.visibility === 'private') {
        this.update.recipient_ids = map(this.recipients, r => r.user ? r.user.id : null)
      }

      const update = await this.$store.dispatch('feed/postUpdate', this.update)
      if (this.feed) {
        this.feed.unshift(update)
      } else {
        this.feed = [update]
      }

      this.update = {
        text: '',
        visibility: 'public'
      }
      this.recipients = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/Activity.vue